module.exports = __webpack_public_path__ + "img/rule-text1.bde2ff55.png";